export default ({
  steps: {
    current: 0,
    max: 4,
  },
  loader: false,
  orderCreated: false,
  pdf: {
    download: '',
    link: '',
  },
  maxPanels: 10000,
  buildings: [],
  selection: {
    activeBuilding: 0,
    activeField: 0,
    activePanels: [],
    fieldName: '',
  },
  panels: [],
  customer: {
    salutation: '',
    company: '',
    firstname: '',
    lastname: '',
    street: '',
    house_nr: '',
    zip: '',
    city: '',
    phone: '',
    email: '',
    confirmEmail: '',
    order_additonal_info: '',
  },
  notification: {
    title: '',
    message: '',
    type: '',
  },
  wording: {},
  supplier: {},
});



// WEBPACK FOOTER //
// ./src/store/state.js